module.exports = __webpack_public_path__ + "static/media/shuffle-cards.a4e2e97f.svg";